// extracted by mini-css-extract-plugin
export default {"busy-timeslots-form":"Feedback_busy-timeslots-form__+mr9Q","c-field-label":"Feedback_c-field-label__+9orL"};